<template>
	<div>
		<Header :sel='4' @changePhone="changePhone" />
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
			<!-- your content here -->
			<!--banner-->
			<div class="banner"> </div>
			<!--banner-->

			<!--neirong-->
			<div class="bread_bg">
				<div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)">知识产权</a></div>
			</div>
			<div class="neirong">


				<ul class="rongyu_list">
					<li v-for="item in list"><el-image :src="item.image"
									:preview-src-list="[item.image]">
						</el-image></li>
				</ul>
			</div>
		</div>
		<Footer></Footer>

	</div>


</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import { getPropertyList } from '@/api/reqFetch.js'
export default {
	name: '',
	layout: '',
	components: {
		Footer,
		Header
	},
	data() {
		return {
			list: [],
			pageNum: 1,
			indexs: [],
			totalPage: 0,
			showPhone: false,

		}
	},

	mounted() {
		this.getData()
	},


	methods: {
		changePhone(val) {
			this.showPhone = val
		},
		goNext(url) {
			this.$router.push({
				path: url,
			})
		},


		getData() {
			let par = {
				pageNumber: 1,
				pageSize: 999,

			}
			getPropertyList(par).then(res => {
				this.list = res.data.list;
			});
		},


	}
}
</script>

<style scoped>
.banner {
	background-image: url('../../assets/images/banner_07.png');
}
</style>
